import * as React from "react";

import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {SettingLimit, PeriodTimeUnit, CurrencyDefinition, Settings} from "../../http/protocol";
import {Form, FormListener} from "../form/Form";
import {getContainer} from "../../ioc/IOCSetup";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {Submit} from "../form/Submit";
import {Validators} from "../form/Validators";
import {SettingsService} from "../../services/SettingsService";
import {SelectInput} from "../form/SelectInput";
import 'react-day-picker/lib/style.css'
import "react-datetime/css/react-datetime.css";
import { BonusSettingLimitService } from "../../services/BonusSettingLimitService";

interface State extends LoadingViewState {
    tc? : SettingLimit;
    validationMap? : any;
    currencies? : CurrencyDefinition[];
}

export class EditSettingLimit extends RouterView<RouteComponentProps,State> implements FormListener<SettingLimit>{

    service : BonusSettingLimitService;
    settingsService : SettingsService;

    constructor(props : RouteComponentProps){
        super(props);
        this.service = getContainer().getBonusSettingLimitService();
        this.settingsService = getContainer().getSettingsService();
        const month:Date = new Date(new Date().setDate(new Date().getDate()+30));

        this.state = { tc : {expires:month }, validationMap : {}, bonusConfigs : [] };
    }

    getTitle(): string {
        return "Edit Global Limits";
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : State) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id)  {
            this.refreshContent();
        }
    }

    loadContent(): Promise<any>  {

        if((this.props.match.params as any).id !== "new") {
            this.settingsService.getSettings().then( (data : Settings)=>{
                this.setState({ currencies : data.currencies })
                return this.service.getEntity((this.props.match.params as any).id).then((tc : SettingLimit) => {
                    this.setState({ tc : tc });
                });
            });

        }
        return this.settingsService.getSettings().then( (s : Settings) => {
            this.setState({  currencies : s.currencies});
        }).then(()=> this.setState({ tc : {} }));

    }

    onSubmit()  {
        if(!this.state.tc) return;

        if(!this.state.tc.currencyCode) {
            return Promise.reject("Currency code muse be set.");
        }

        return this.service.save(this.state.tc).then((s : SettingLimit)=> {
            if((this.props.match.params as any).id === "new") {
                this.navigate("/bonus/setting-limit/" + s.id);
            } else {
                this.setState({ category : s });
            }

        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
    }

    formDidUpdate(formModel: SettingLimit, validationMap?: any) {
        this.setState({tc : formModel, validationMap : validationMap})
    }
    getCurrencyLabel(code : string) {
        if(this.state.currencies) {
            let c = this.state.currencies.find( c => c.code === code);
            if(c) {
                return c.name + " (" + c.code + ")";
            }
        }
        return "";
    }
    
    renderContent() {
        if(!this.state.tc || !this.state.currencies) {
            return <span></span>
        }

        return (
            <div>


                <div className="wrapper wrapper-content animated fadeInRight">
                    <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.tc} formListener={this}>
                        <div className="row">
                            <div className="col-lg-12">

                                <div className="card-box">
                                    <div className="ibox-content">
                                        
                                        {(this.props.match.params as any).id !== "new" && (
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">ID</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="id" type="integer"  className="form-control" disabled={true}/>
                                                </div>
                                            </FormGroup>
                                        )}

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Currency</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="currencyCode" values={this.state.currencies.map(c => c.code)} className="form-control"
                                                    disabled={(this.props.match.params as any).id !== "new"}
                                                 />
                                                <span className={"help"}>Currency of this limit</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Period Type</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="maxPaidPeriodUnit" optional={true} values={Object.keys(PeriodTimeUnit)} className="form-control" />
                                                <span className={"help"}>The type of timeframe units that will be used to calculate the total bonus paid amount.</span>
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Period Value</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxPaidPeriodValue" validators={[]} type="text"  className="form-control" />
                                                <span className={"help"}>The value for the period.</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Max Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxPaidTotalAmount"  type={"float"} className="form-control" validators={[Validators.number()]} />
                                                <span className={"help"}>The max amount limit. If 0 the no bonus can be awarded at all to anyone.</span>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">

                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Limit was updated successfully"/>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}


export default withRouter(EditSettingLimit);